import React, { useState } from "react";
import parse from "html-react-parser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIndianRupeeSign } from "@fortawesome/free-solid-svg-icons";
import ImageGallery from "./ImageGallery";
import CallData from "./CallData";

const stripHtmlTags = (html) => {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
};

const ChatMessageItem = ({ data, message, isSentByYou, time }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const alignmentClass = isSentByYou ? "justify-content-end me-2" : "justify-content-start";
    const bubbleClass = isSentByYou ? "bg-sent" : "bg-recive";
    const timeClass = isSentByYou ? "message-time-sent" : "message-time-recive";

    const plainText = stripHtmlTags(message);
    const shouldTruncate = plainText.length > 1000;
    const truncated = shouldTruncate && !isExpanded
        ? plainText.slice(0, 1000) + "..."
        : plainText;

    const toggleExpand = () => setIsExpanded((prev) => !prev);
    //Quotation Message
    const quotationQuote = data?.quote;
    const payment_details = data?.payment_details;
    const gallery_data = data?.gallery;
    const call_data = data?.call;
    const bubbleClassQuotation = isSentByYou ? "bg-sent quotation" : "bg-recive quotation";

    // const handleEditClick = (quotationQuote) => {
    //     const park_id = parks?.find((park) => park?.label === quotationQuote?.park_label)?.value;
    //     const safari_category_id = safariCategory?.find((cate) => cate?.label === quotationQuote?.staycatgory_lable)?.value;

    //     const formatDate = (dateStr) => {
    //         return dateStr ? dayjs(dateStr, 'MMM DD, YYYY').format('YYYY-MM-DD') : '';
    //     };


    //     const setQuotation = {
    //         safaris: quotationQuote?.safaris,
    //         travelers: quotationQuote?.travelers,
    //         stay_category_id: safari_category_id,
    //         start_date: formatDate(quotationQuote?.start_date),
    //         end_date: formatDate(quotationQuote?.end_date),
    //         park_id: park_id,
    //         addional_notes: quotationQuote?.addional_notes,
    //         partner_selling_price: quotationQuote?.net_payment_price
    //     }
    //     messageDispatch({
    //         type: "UPDATE_QUOTATION_FORM_DATA",
    //         payload: setQuotation,
    //     });
    //     messageDispatch({ type: "QUOTATION_FORM_TOGGLE", payload: true });
    // }



    return (
        <>
            {message &&
                <div className={`chat-message-container d-flex mb-2 ${alignmentClass}`}>
                    <div
                        className={`d-inline-block px-2 py-1 ${bubbleClass}`}
                        style={{
                            maxWidth: "65%",
                            wordWrap: "break-word",
                        }}
                    >
                        <div className="me-5 chat-text">
                            {parse(truncated)}
                        </div>
                        {shouldTruncate && (
                            <div className="d-flex justify-content-end me-2">
                                <button
                                    onClick={toggleExpand}
                                    style={{
                                        background: "none",
                                        border: "none",
                                        padding: 0,
                                        marginTop: "4px",
                                        color: "#007bff",
                                        cursor: "pointer",
                                        fontSize: "0.875rem",
                                    }}
                                >
                                    {isExpanded ? "Show less" : "Show more"}
                                </button>
                            </div>
                        )}
                        <div className="d-flex justify-content-end mx-0 mt-2 mb-0">
                            <span className={`m-0 message-time ${timeClass}`}>
                                {time}
                            </span>
                        </div>
                    </div>

                </div>

            }
            <>
                {quotationQuote && (
                    <div className={`chat-message-container d-flex mb-2 ${alignmentClass}`}>
                        <div
                            className={`d-inline-block px-3 py-3 ${bubbleClassQuotation}`}
                            style={{
                                maxWidth: "65%",
                                wordWrap: "break-word",
                            }}
                        >
                            <div className="d-flex justify-content-start gap-5 align-items-center mb-3">
                                <div className="fw-bold">Itinerary & Quotation</div>
                                {/* {isSentByYou && <button
                                    type="button"
                                    className="btn p-0 border-0 bg-transparent"
                                    onClick={() => { handleEditClick(quotationQuote) }} // replace with your actual function
                                    aria-label="Edit Quotation"
                                >
                                    <FontAwesomeIcon
                                        icon={faEdit}
                                        color="#141414"
                                        size="lg"
                                    />
                                </button>
                                } */}
                            </div>

                            <div className="d-flex flex-column gap-1 quatation-text">
                                <div><span className="quotatio-points">Park:</span> <span>{quotationQuote?.park_label}</span></div>
                                <div><span className="quotatio-points">Safaris:</span>  <span>{quotationQuote?.safaris}</span></div>
                                <div><span className="quotatio-points">Travelers:</span>   <span>{quotationQuote?.travelers}</span></div>
                                <div><span className="quotatio-points">Stay Category:</span>  <span>{quotationQuote?.staycatgory_lable}</span></div>
                                <div><span className="quotatio-points">Start Date:</span>  <span>{quotationQuote?.start_date}</span></div>
                                <div><span className="quotatio-points"> End Date:</span>  <span>{quotationQuote?.end_date}</span></div>

                                {quotationQuote?.addional_notes && (
                                    <div>
                                        <h6 className="mt-2 mb-1">Notes:</h6>
                                        <div>{parse(quotationQuote?.addional_notes || '')}</div>
                                    </div>
                                )}
                                <div className="d-flex justify-content-between gap-5 mt-3">
                                    <div>
                                        <FontAwesomeIcon
                                            icon={faIndianRupeeSign}
                                            color="#e68619"
                                            size="2x"
                                        />
                                        <span className="quotation-price ms-2">{quotationQuote?.net_payment_price}</span>
                                    </div>
                                    <div className="joinsafari">
                                        {payment_details &&
                                            <a href={payment_details?.payment_initiate_link} target="_blank">
                                                Pay
                                            </a>

                                        }

                                    </div>
                                </div>
                            </div>
                            <div className="d-flex justify-content-end mt-3">
                                <span className={`m-0 message-time ${timeClass}`}>
                                    {time}
                                </span>
                            </div>
                        </div>
                    </div>
                )}
            </>
            <>
                {gallery_data && (
                    <div className={`chat-message-container d-flex mb-2 ${alignmentClass}`}>
                        <div
                            className={`d-inline-block px-2 py-2 ${bubbleClassQuotation}`}
                            style={{
                                maxWidth: "65%",
                                minWidth: "65%",
                                wordWrap: "break-word",
                            }}
                        >
                            <ImageGallery gallery_data={gallery_data} />
                            <div className="d-flex justify-content-end mt-0">
                                <span className={`m-0 message-time ${timeClass}`}>
                                    {time}
                                </span>
                            </div>
                        </div>
                    </div>

                )}

            </>
            <>
                {call_data && (
                    <div className={`chat-message-container d-flex mb-2 ${alignmentClass}`}>
                        <div
                            className={`d-inline-block px-3 py-3 ${bubbleClassQuotation}`}
                            style={{
                                maxWidth: "65%",
                                minWidth: "65%",
                                wordWrap: "break-word",
                            }}
                        >
                            <CallData callData={call_data} />
                            <div className="d-flex justify-content-end mt-3">
                                <span className={`m-0 message-time ${timeClass}`}>
                                    {time}
                                </span>
                            </div>
                        </div>
                    </div>

                )}

            </>

        </>
    );
};

export default ChatMessageItem;
